import { render } from "./DetailTasteOfBook.vue?vue&type=template&id=b737044a&scoped=true"
import script from "./DetailTasteOfBook.vue?vue&type=script&lang=js"
export * from "./DetailTasteOfBook.vue?vue&type=script&lang=js"

import "./DetailTasteOfBook.vue?vue&type=style&index=0&id=b737044a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b737044a"

export default script